import Vue from 'vue';
import Vuex from 'vuex';

import EntryProxy from '@/app/proxies/EntryProxy';
import entry from './modules/entry';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,
    modules: {
        entry
    },

    state: {
        ABTest: null,
        isKnownPlayer: false,
        savedEntry: null,
        firstBall: 0,
        answers: [],
        balls: [],
        debug: false
    },

    getters: {
        ABTest: state => state.ABTest,
        getDebug: state => state.debug,
        isKnownPlayer: ( state ) => state.knownPlayer,
        getEntry: state => state.savedEntry,
        getAnswers: state => state.answers,
        getCorrectAnswers: state => state.answers.filter( answer => answer === true ),

        getFirstBall: state => state.firstBall,
        getBalls: state => state.balls,
        getCorrectBalls: state => state.balls.filter( ( ball, index ) => state.answers[index] !== false )
    },

    mutations: {
        setABTest( state, value )
        {
            state.ABTest = value;
        },

        knownPlayer( state, value )
        {
            state.knownPlayer = value;
        },

        savedEntry: ( state, payload ) =>
        {
            state.savedEntry = payload;
        },

        saveAnswer: ( state, payload ) =>
        {
            state.answers.push( payload );
        },

        saveBall: ( state, payload ) =>
        {
            state.balls.push( payload );
        },

        resetBalls: ( state, payload ) =>
        {
            state.balls = [];
        },

        resetAnswers: ( state, payload ) =>
        {
            state.answers = [];
        },

        setDebug: state =>
        {
            state.debug = true;
        }
    },

    actions: {
        setABTest( context, payload )
        {
            context.commit( 'setABTest', payload );
        },

        setDebug( context )
        {
            context.commit( 'setDebug' );
        },

        knownPlayer( context, payload )
        {
            context.commit( 'knownPlayer', payload );
        },

        saveEntry( context, payload )
        {
            let data = payload;
            data['num_correct'] = context.getters.getAnswers.filter( guess => guess === true ).length.toString();

            context.commit( 'savedEntry', data );

            return new EntryProxy()
                .create( data )
                .then( ( response ) =>
                {
                    // context.commit( 'savedEntry', response );
                    return response;
                })
                .catch( ( error ) =>
                {
                    return Promise.reject( error );
                });
        },

        answerGiven( context, payload )
        {
            this.commit( 'saveAnswer', payload.correct );
            this.commit( 'saveBall', payload.ball );
        },

        resetGame( context )
        {
            this.commit( 'resetBalls' );
            this.commit( 'resetAnswers' );
        }
    }
});



// WEBPACK FOOTER //
// ./src/app/store/index.js